/**
 * La tasa 2 (paralela), el factor y la explicación de cómo se calcula el cobro («a tasa 2…», «a tasa BCV… + IGTF; con
 * el resto en Bs…») solo los ve la dueña (superadmin). Los demás roles (administrador, cajero, almacén, contador) ven
 * cuánto se cobra en bolívares y en dólares y lo que falta, nunca la tasa ni la regla. Es solo lo que se muestra: los
 * cálculos, las tasas y la API no cambian, y la BCV sigue a la vista (pedido de la dueña 2026-10-19).
 */
import type { UsuarioSesion } from '@mg/shared';
import { useAuthOpcional } from './auth.tsx';

export function veTasa2(usuario: Pick<UsuarioSesion, 'rol'> | null | undefined): boolean {
  return usuario?.rol === 'superadmin';
}

/** El usuario de la sesión ve la tasa 2 y la regla del cobro. Sin sesión (pruebas, hojas sueltas) no se muestran. */
export function useVeTasa2(): boolean {
  return veTasa2(useAuthOpcional()?.usuario);
}

/**
 * La parte del saldo a favor que entró en divisas sin IGTF (paga el 3 % al usarse en una factura) la ven la dueña y el
 * contador, en la ficha del cliente, en sus movimientos y en el recibo del abono; el cajero y el administrador no
 * (hallazgo T20, con la decisión del 2026-10-19). La API repite esta lista y a los demás les devuelve null.
 */
export function veParteDivisa(usuario: Pick<UsuarioSesion, 'rol'> | null | undefined): boolean {
  return usuario?.rol === 'superadmin' || usuario?.rol === 'contador';
}
